import { rem } from 'polished';

import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import { CheckoutTitleStyled } from '../CheckoutTitleStyled';

export const CheckoutTitleStyledAC = styled(CheckoutTitleStyled)`
    .b2b {
        font-size: ${rem(32)};
        line-height: ${rem(35)};
        font-family: ${({ theme }) => theme.fonts.fontSecondary};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};

        @media (min-width: ${breakpoints.sm}px) {
            font-size: ${({ theme }) => theme.fontSizes.h1};
            line-height: ${rem(45)};
        }

        @media (min-width: ${breakpoints.lg}px) {
            width: ${rem(800)};
        }
    }
`;
